var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.ee0{fill:#FFFFFF;}\n\t.ee1{fill:#216C58;stroke:#216C58;stroke-width:42;stroke-miterlimit:22.9256;}\n\t.ee2{fill:#216C58;}\n\t.ee3{fill:#FFFFFF;stroke:#216C58;stroke-width:42;stroke-miterlimit:22.9256;}\n\t.ee4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1996163666768"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ee0",
    d: "M1250,0L1250,0c690,0,1250,560,1250,1250l0,0c0,690-560,1250-1250,1250l0,0C560,2500,0,1940,0,1250l0,0    C0,560,560,0,1250,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ee1",
    cx: 1250,
    cy: 1250,
    r: 1167
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee2",
    d: "M2333,1250c0,598-485,1083-1083,1083S167,1848,167,1250S652,167,1250,167S2333,652,2333,1250z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1104,
    y: 1771,
    className: "ee2",
    width: 125,
    height: 125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1312,
    y: 1771,
    className: "ee2",
    width: 125,
    height: 125
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee0",
    d: "M896,479h792c23,0,42,19,42,42v21c0,23-19,42-42,42H896c-23,0-42-19-42-42v-21C854,498,873,479,896,479z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee0",
    d: "M1250,625v1417c0,23-19,42-42,42h-21c-23,0-42-19-42-42V625h104H1250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee0",
    d: "M1417,625v1417c0,23-19,42-42,42h-21c-23,0-42-19-42-42V625h104H1417z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee3",
    d: "M1161,978L1161,978L1161,978c29-11,66-16,110-16c66,0,115,13,151,36c25,17,42,38,51,63s32,50,65,50h192    c34,0,65-29,60-66c-8-58-30-110-65-156c-44-58-106-102-183-133c-77-32-167-47-269-47c-100,0-190,16-270,47s-143,76-190,133l0,0    l0,0c-47,58-70,126-70,203c0,94,35,171,106,227c69,55,162,94,277,119l0,0l146,33l0,0l0,0c48,10,89,22,121,34l0,0    c32,12,55,26,70,42l0,0l0,0c14,14,21,31,21,53c0,24-8,44-24,63c-17,19-41,35-75,46l0,0c-33,11-72,18-118,18c-47,0-89-6-125-19    s-63-31-84-54c-13-15-22-33-28-54c-7-28-32-53-65-53H772c-35,0-65,29-60,66c8,71,32,132,71,184l0,0c48,62,114,107,197,138l0,0    c83,31,180,46,291,46s207-15,287-45l0,0c81-31,144-74,187-131c45-58,67-126,67-203l0,0l0,0c0-53-11-100-33-142    c-21-41-51-77-89-107s-82-55-132-75s-105-36-165-48l-121-26l0,0l0,0c-29-6-55-13-80-20c-25-8-46-18-64-28c-17-10-31-22-40-35    c-8-12-12-26-11-43l0,0l0,0c0-21,7-39,20-56c14-17,35-31,64-41V978z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1146,
    y: 896,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1146,
    y: 1417,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1146,
    y: 1854,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1313,
    y: 896,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1313,
    y: 1417,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1313,
    y: 1854,
    className: "ee0",
    width: 104,
    height: 146
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee4",
    d: "M2298,1313c-17,0-30,13-32,29c-46,521-484,929-1017,929s-970-408-1017-929c-1-17-15-29-32-29    c-18,0-32,15-31,33c48,554,513,988,1079,988s1031-434,1079-988c2-18-13-33-31-33H2298z M201,1188c17,0,30-13,32-29    c46-521,484-929,1017-929s970,408,1017,929c1,17,15,29,32,29c18,0,32-15,31-33c-48-554-513-988-1079-988S220,601,172,1155    c-2,18,13,33,31,33H201z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdd);
export default __webpack_public_path__ + "static/media/usdd.8396f89a97084989efa4c4cb60f7c49b.svg";
export { ForwardRef as ReactComponent };